import * as Yup from "yup";

/**
 * Schema de validação para Accounting Records (Geração Contábil).
 * 
 * Este modelo foca em REGIME DE COMPETÊNCIA. Isso significa que uma venda gera
 * uma RECEITA pelo seu valor integral na data em que ocorreu, e as despesas
 * (como as taxas do cartão cobradas) geram outro registro no mesmo período.
 * Fluxo de recebimento ao longo dos meses vive na entidade "financialRecord".
 */
export const accountingRecordSchema = Yup.object().shape({
    idSale: Yup.string().nullable(),
    saleNumber: Yup.string().nullable(),

    type: Yup.string()
        .oneOf(["INCOME", "EXPENSE"])
        .required("Classificação de Receita/Despesa é obrigatória para a DRE"),
    
    idCategory: Yup.string().required("Obrigatório referenciar uma Categoria Contábil"),
    categoryName: Yup.string().nullable(),

    // Referência de Custo/Cliente:
    idEntity: Yup.string().nullable(),
    entityName: Yup.string().nullable(),
    sourceType: Yup.string().oneOf(["MEMBER", "ACQUIRER", "SUPPLIER", "EMPLOYEE"]).nullable(),

    idMember: Yup.string().nullable(),
    memberName: Yup.string().nullable(),

    idEmployee: Yup.string().nullable(),
    employeeName: Yup.string().nullable(),

    // Valor da Operação na Competência
    amount: Yup.number()
        .min(0, "O Valor não pode ser negativo")
        .required("Valor consolidado é obrigatório"),

    // Para o Accounting (DRE), só existe DUAS datas importantes:
    // A data em que foi emitida e a Data da Competência desse montante.
    issueDate: Yup.string()
        .matches(/^\d{4}-\d{2}-\d{2}$/, "Formato de data inválido (YYYY-MM-DD)")
        .required("Data de emissão obrigatória"),
        
    competenceDate: Yup.string()
        .matches(/^\d{4}-\d{2}-\d{2}$/, "Formato de data inválido (YYYY-MM-DD)")
        .required("Data de competência é obrigatória para relatórios da DRE"),
    
    // Status do Assentamento Contábil (usualmente COMPLETED na geração).
    status: Yup.string().oneOf(["COMPLETED", "CANCELED"]).default("COMPLETED"),

    description: Yup.string().required("Uma descrição clara para o livro contábil é obrigatória"),
    notes: Yup.string().nullable()
});
